/**
 * Set a key/value pair in local storage, fall back to session storage if local storage isn't available
 * @param key
 * @param value
 */
export const setItem = (key, value) => {
    if (typeof window !== 'undefined') {
        if (key) {
            try {
                localStorage.setItem(key, value);
            }
            catch (e) {
                // Fall back to sessionStorage if localStorage not supported
                sessionStorage.setItem(key, value);
            }
        }
    }
};
/**
 * Get a value by key from local storage, fall back to session storage if local storage isn't available
 * @param key
 */
export const getItem = (key) => {
    if (typeof window !== 'undefined') {
        try {
            return localStorage.getItem(key);
        }
        catch (e) {
            // Fall back to sessionStorage if localStorage not supported
            return sessionStorage.getItem(key);
        }
    }
    /* istanbul ignore next */
    return null;
};
//# sourceMappingURL=storage.js.map